import React from 'react';
import { Outlet } from 'react-router';

const AuthLayout = () => (
  <div className="container-fluid position-relative d-flex p-0">
    <Outlet />
  </div>
);

export default AuthLayout;